export const USER_CATEGORY = {
 PMU_BAYER: 'pmu_bayer',
 PMU_RP: 'pmu_rp',
 SR_DL: 'sr_dl',
 DL: 'dl',
 PROJECT_COORDINATOR: 'project_coordinator',
 DISTRIBUTOR_DIRECTOR: 'distributor_director',
 DISTRIBUTOR_USER: 'distributor_user',
 OFFTAKER_ADMIN: 'offtaker_admin',
 OFFTAKER_USER: 'offtaker_user',
 SR_MLC: 'sr_mlc',
 MLC: 'mlc',
 IM_ADMIN: 'im_admin',
 RBM: 'rbm',
 TSU_USER: 'tsu_user',
} as const

export type UserCategoryKey =
 (typeof USER_CATEGORY)[keyof typeof USER_CATEGORY]
